import { ethers } from "ethers";
import {
  nils,
  iso,
  nano,
  tofeth,
  toeth,
  tofpval,
  topval,
  blocktime_iso,
  base64_to_json,
  getv,
} from "../../utils/utils.jsx";
import _ from "lodash";
import abi from "./abis/DNA_SkinsStore.json";
import { CV2_Contract } from "./cv2_base.js";
import { contractAddress_list } from "../contracts.jsx";
import get_logs_parser from "./extra_logs_parsers.js";
import DNA_SkinsStore_BulkGetter from "./DNA_SkinsStore_BulkGetter.js";

const k = "dnaskinsstore";
class Contract extends CV2_Contract {
  constructor({ contract_k, contractAddress, aumode, abi, ...ext }) {
    super({ contract_k, contractAddress, aumode, abi, ...ext });
  }

  async getParsedLogs(logs) {
    if (!logs) return [];

    let logrows = [];
    for (let log of logs) {
      let iface = new ethers.Interface(this.abi);
      let par = iface.parseLog(log);

      if (nils(par)) continue;

      let name = par.name;
      let o = {
        name,
        logIndex: log.logIndex,
        hash: log.transactionHash,
        blockNumber: log.blockNumber,
      };
      o.id = `${o.hash}:${o.logIndex}`;

      // event SkinPurchased(string id, uint amt, string token, address vault)
      if (name == "SkinPurchased") {
        let a = par.args;
        let token = a[2];
        let amt = Number(a[1]);
        let args = { id: a[0], token, vault: a[3].toLowerCase() };

        if (token == "SGC") {
          args.amt_tok = parseFloat(tofeth(amt));
        } else {
          args.amt_usd = parseFloat(tofpval(amt));
          let e20rows = get_logs_parser.erc20(logs);
          let e20transfer = _.find(e20rows, (e) => e.name == "Transfer");
          if (e20transfer) {
            args.amt_tok = parseFloat(tofeth(getv(e20transfer, "args.2")));
          }
        }
        let skinrows = get_logs_parser.base_skin(logs);
        // console.log("skinrows", skinrows.length);
        // console.log(skinrows);
        args.skins = _.map(skinrows, "args");
        o.args = args;
      }

      // event SkinPackPurchased(string name, uint amt, string token, address vault)
      if (name == "SkinPackPurchased") {
        let a = par.args;
        let amt = Number(a[1]);
        let token = a[2];
        let args = {
          id: a[0],
          token,
          vault: a[3].toLowerCase(),
        };

        if (token == "SGC") {
          args.amt_tok = parseFloat(tofeth(amt));
        } else {
          args.amt_usd = parseFloat(tofpval(amt));
          let e20rows = get_logs_parser.erc20(logs);
          let e20transfer = _.find(e20rows, (e) => e.name == "Transfer");
          if (e20transfer) {
            args.amt_tok = parseFloat(tofeth(getv(e20transfer, "args.2")));
          }
        }

        let skinrows = get_logs_parser.base_skin(logs);
        // console.log("skinrows", skinrows.length);
        // console.log(skinrows);
        args.skins = _.map(skinrows, "args");
        o.args = args;
      }

      logrows.push(o);
    }
    return logrows;
  }

  async get_SkinIndi(id) {
    const skin = await this.run("get_SkinIndi", [id]);
    if (!skin) return null;
    if (nils(skin[0])) return null;

    let a = 0;
    let p = {
      id: skin[a++],
      rvmode: skin[a++],
      name: skin[a++],
      rarity: skin[a++],
      price_usdp: skin[a++].toString(),
      price_sgcw: skin[a++].toString(),
      active: skin[a++],
    };
    p.price_usd = parseFloat(tofpval(p.price_usdp));
    p.price_sgc = parseFloat(tofeth(p.price_sgcw));

    return p;
  }

  async get_SkinPack(id) {
    const skin = await this.run("get_SkinPack", [id]);
    if (!skin) return null;
    if (nils(skin[0])) return null;

    let a = 0;
    let p = {
      id: skin[a++],
      name: skin[a++],
      override_price: skin[a++],
      price_usdp: skin[a++].toString(),
      price_sgcw: skin[a++].toString(),
      active: skin[a++],
      skinindi_ids: skin[a++],
    };
    p.skinindi_ids = Array.from(p.skinindi_ids);
    if (p.override_price !== true) {
      p.price_usdp = 0;
      p.price_sgcw = 0;
      p.price_usd = 0;
      p.price_sgc = 0;

      let skinids = p.skinindi_ids;
      // console.log("skinids", skinids.length, skinids);
      const con_storebget = await DNA_SkinsStore_BulkGetter.get_contract();
      let ar = await con_storebget.run("bulk_get_SkinIndi_mini", [skinids]);
      // console.log("ar", ar);
      let prices_usdp = Array.from(getv(ar, "1"));
      let prices_sgcw = Array.from(getv(ar, "2"));
      p.price_usd = _.chain(prices_usdp)
        .map((p) => parseFloat(tofpval(p)))
        .sum()
        .value();
      p.price_usdp = topval(p.price_usd);
      p.price_sgc = _.chain(prices_sgcw)
        .map((p) => parseFloat(tofeth(p)))
        .sum()
        .value();
      p.price_sgcw = toeth(p.price_sgc);
    } else {
      p.price_usd = parseFloat(tofpval(p.price_usdp));
      p.price_sgc = parseFloat(tofeth(p.price_sgcw));
    }
    return p;
  }
}

const get_contract_address = () => {
  return contractAddress_list.skinsstore;
};

const get_contract = async (ext = {}) => {
  const contractAddress = get_contract_address();
  const runner = new Contract({
    contract_k: k,
    contractAddress,
    aumode: ext.aumode || "thirdweb",
    abi,
    ...ext,
  });
  return runner;
};

const DNA_SkinsStore = {
  k,
  get_contract,
  get_contract_address,
};

export default DNA_SkinsStore;
